export const PublicRoutes =
    /\/change-password|\/sign-up|\/therapist-user-signup|\/providers|\/initquestions|\/forgot-password|\/reset-password|\/support|\/redirect|\/verify-onboarding|\/error|\/termsofservice|\/register|\/login|\/privacypolicy|\/profile|\/verification|/.test(
        window.location.pathname
    );

export const ShouldLoggoutRoutes =
    /\/login|\/sign-up|\/therapist-user-signup|\/forgot-password|\/reset-password|\/verify-onboarding|\/privacypolicy|\/support|\/redirect|\/support|\/error/.test(
        window.location.pathname
    );

export const PrivateRoutes =
    /\/therapy|\/error|\/scheduler|\/settings|\/profile|\/intake-report|\/session-ended|\request-rematch|\/activity-log|\/meeting-info|\/register|\/verify-onboarding|\/termsofservice|\/privacypolicy|\/profile|\/teletherapy|\/practice-admin|\/super-admin|\/resources/.test(
        window.location.pathname
    );

export const ShouldLoggoutAndRedirectRoutes = /\/providers|\/therapist-user-signup|\/sign-up/.test(
    window.location.pathname
);

export const NoHeaderRoutes = 
    /\/teletherapy\/meeting-room|\/teletherapy\/waiting-room|\/greetings/.test(
        window.location.pathname
    );
